import { render, staticRenderFns } from "./resultPop.vue?vue&type=template&id=d34bc12c&scoped=true"
import script from "./resultPop.vue?vue&type=script&lang=js"
export * from "./resultPop.vue?vue&type=script&lang=js"
import style0 from "./resultPop.vue?vue&type=style&index=0&id=d34bc12c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34bc12c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d34bc12c')) {
      api.createRecord('d34bc12c', component.options)
    } else {
      api.reload('d34bc12c', component.options)
    }
    module.hot.accept("./resultPop.vue?vue&type=template&id=d34bc12c&scoped=true", function () {
      api.rerender('d34bc12c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemAdministrator/brandSelection/components/resultPop.vue"
export default component.exports